export const $flatmap = new Map();

export default {
  $flatmap
}

$flatmap.store = () => {

}

$flatmap.restore = () => {

}
